import { motion } from "framer-motion";
import {
  Waves, Wind, Wifi, ChefHat, Tv, Sun, Car, KeyRound, Coffee, BedDouble, WashingMachine, ShowerHead,
} from "lucide-react";
import { useI18n } from "../../i18n";

const ICONS = [Waves, Wind, Wifi, ChefHat, Tv, Sun, Car, KeyRound, Coffee, BedDouble, WashingMachine, ShowerHead];

export default function Services() {
  const { t } = useI18n();
  return (
    <section className="py-28 md:py-36 lg:py-44 px-6 md:px-12 lg:px-20" data-testid="services-section">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-12 gap-y-10 gap-x-8 mb-12 md:mb-20">
          <div className="col-span-12 md:col-span-5">
            <span className="eyebrow">{t.services.eyebrow}</span>
            <motion.h2
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 1 }}
              className="font-serif-display text-4xl md:text-5xl lg:text-6xl text-charcoal mt-4 whitespace-pre-line"
              data-testid="services-title"
            >
              {t.services.title}
            </motion.h2>
          </div>
          <div className="col-span-12 md:col-span-7 md:pl-8 lg:pl-16 flex items-end">
            <p className="text-charcoal-soft text-base md:text-lg leading-relaxed max-w-md">
              {t.services.list.length}{" "}
              <span className="italic font-serif">essenziali</span> attentamente
              selezionati per un soggiorno fluido, silenzioso, mediterraneo.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-x-6 md:gap-x-10 gap-y-10 md:gap-y-14">
          {t.services.list.map((label, i) => {
            const Icon = ICONS[i] || Sun;
            return (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-40px" }}
                transition={{ duration: 0.7, delay: (i % 5) * 0.08 }}
                className="flex flex-col items-start gap-4 group"
                data-testid={`service-${i}`}
              >
                <Icon
                  size={26}
                  strokeWidth={1.1}
                  className="text-charcoal/80 transition-transform duration-700 group-hover:-translate-y-0.5"
                />
                <span className="text-sm md:text-[0.95rem] text-charcoal leading-snug font-light">
                  {label}
                </span>
                <span className="block w-6 h-px bg-charcoal/15 group-hover:bg-charcoal/60 group-hover:w-10 transition-all duration-700" />
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
